export const helpUrls = {
  customerSupport: 'https://t.me/ProjectSerum',
  customerSupportZh: 'https://t.me/ProjectSerum_Chinese',
  contactEmail: 'mailto:contact@projectserum.com',
  discord: 'https://discord.gg/EDvudv6',
  telegram: 'https://t.me/ProjectSerum',
  github: 'https://github.com/project-serum',
  projectSesame: 'https://projectserum.com/',
  developerResources: 'https://projectserum.com/developer-resources',
  solanaBeach: 'https://solanabeach.io',
  domichainSite: 'https://www.dominochain.com',
};
